<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div class="row">
            <div class="col-lg-12">
                <h3>Step 2: Record Video</h3>
                <p class="info">
                    <i class="icon-error_outline"></i>Please point video camera
                    on customer face and make sure their straight face is
                    completely visible in the video. Click on Record button to
                    record 10 seconds video.
                </p>
                <div
                    class="video-record"
                    :class="
                        showVideo == true
                            ? 'videoRecored'
                            : '' || timeShow == true
                            ? 'videoRecored'
                            : ''
                    "
                >
                    <div class="show-record-video">
                        <video-js-record
                            @recordingStarted="onVideoRecording"
                            @recordingEnded="onRecordingEnded"
                        ></video-js-record>
                    </div>
                    <div
                        :class="showVideo == true ? 'video-recorded' : ''"
                        class="video-play"
                    >
                        <span v-if="timeShow" class="timer-countdown">{{
                            countDown
                        }}</span>
                        <i class="icon-record">
                            <i class="path1"></i>
                            <i class="path2"></i>
                            <i class="path3"></i>
                        </i>
                        <p v-if="showVideo == false">Record</p>
                        <p v-if="showVideo == true">Finish</p>
                    </div>
                </div>
                <base-button
                    v-if="showVideo"
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="CONTINUE"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>
            </div>
        </div>
    </b-form>
</template>
<script>
import videoJsRecord from '@/components/VideoJSRecord.vue'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
export default {
    components: {
        videoJsRecord,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            countDown: 10,
            showVideo: false,
            timeShow: false,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId', 'loading']),
        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-setup-profile',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/register-customer/setup-profile')
            }
        }, // End of onSubmit() method

        onVideoRecording() {
            this.timeShow = true
            this.showVideo = false
            this.countDownTimer()
        },
        async onRecordingEnded(player) {
            this.showVideo = true
            this.timeShow = false
            this.countDown = 10

            try {
                const formData = new FormData()
                formData.append('type', 'video')
                formData.append('file', player.recordedData, 'video.mp4')

                const headers = {
                    'Content-Type': 'multipart/form-data',
                }

                const { data } = await request.post('files/', formData, {
                    headers,
                })

                this.$store.commit('updateField', {
                    key: 'documentInfo.video.fileName',
                    value: data.data.fileName,
                })
            } catch (error) {
                console.log(error)
            }
        },

        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
